__turbopack_context__.v({
  "article": "UCvRoq_article",
  "link": "UCvRoq_link",
});
